
import { GlobalEventsManager } from './services/gobal-events-manager';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
 
@Injectable()
export class AuthGuard implements CanActivate {
 
    constructor(private router: Router, private globalEventsManager: GlobalEventsManager) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('currentUser')) {
            // logged in so return true
           this.globalEventsManager.showNavBar.emit(true);
            return true;
        }
       
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
  
    isLoggedIn(): boolean{
      if (localStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }else {
            return false;
      }
    }
}


// WEBPACK FOOTER //
// ./src/app/auth.guard.ts